import React, { useContext, useEffect, useState, useMemo } from "react";
import "./Dialogs.css";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import DialogsWrapper from "./DialogsWrapper";
import * as c from "utils/constants/constants";
import * as msg from "utils/constants/messages";
import {
    NoDocumentAvailable,
    BlockSaveWarning,
    DiscardWarning,
    NotificationWarning,
    FlagNotesWarning,
    NotAvailableWarning,
    PartialDocSplitWarning,
    PatientCreateError,
    SaveMessage,
    SpamAlert,
    SpamValidation,
    SplitMessage,
    UploadWarning,
    UploadValidation,
    CompleteWarning,
    SkipUploadWarning,
    NoChangesWarning
} from "./Components";

const Dialogs = (props) => {
    const {
        data = {},
        dialogs = {},
        setDialogs,
        getDocumentDetailDataAfterUpdate,
        updateDocumentData,
        setLoader,
        saveAllData,
        getDocId,
        gotToDocMgmt,
        documentId,
        previousData,
        splitDocument,
        setDocSplitData,
        getSplitProgressPercentage,
        uploadDocumentToOnbase,
        completeDocument,
        skipUpload,
        setDataSave
    } = useContext(DocumentDetailContext);

    const [dialog, setCurrentDialog] = useState("");

    useEffect(() => {
        let temp = ""
        Object.keys(dialogs).forEach(m => {
            if (dialogs[m]) {
                temp = m
            }
        });
        setCurrentDialog(temp)
    }, [dialogs, data]);

    const handleClose = () => {
        setDialogs(prevState => ({
            ...prevState,
            [dialog]: false
        }));
        typeof props.handleClose == "function" && props.handleClose(dialog);
        setCurrentDialog(null);
    }

    const handleRefresh = async () => {
        setLoader(prevState => ({
            ...prevState,
            miniLoader: true
        }));
        setDataSave(false);
        var res = JSON.parse(JSON.stringify(previousData));
        setDocSplitData(prevState => ({
            ...prevState,
            docSplitData: res.Entity_Details.docSplitData || [],
            splitProgressPercentage: getSplitProgressPercentage(res.Entity_Details.docSplitData || [])
        }));
        let data = await getDocumentDetailDataAfterUpdate(documentId);
        updateDocumentData(data);

    }

    const handleSubmit = async () => {
        setDialogs(prevState => ({
            ...prevState,
            [dialog]: false
        }));
        if (dialog == "duplicateWarning") {
            await saveAllData("duplicate");
        } else if (dialog == "careEveryWhereWarning") {
            await saveAllData("care_everywhere");
        } else if (dialog == "spamWarning") {
            await saveAllData("spam");
        } else if (dialog == "errorWarning") {
            await saveAllData("error");
        } else if (dialog == "flagNotesNotFilledWarning") {
            setDialogs(prevState => ({
                ...prevState,
                [dialog]: false
            }));
            await saveAllData("save", true);
        } else if (dialog == "partialDocumentSplitWarning") {
            splitDocument()
        } else if (dialog == "discardWarning" || dialog == "blockSave") {
            handleRefresh();
        } else if (dialog == "uploadWarning") {
            uploadDocumentToOnbase()
        } else if (dialog == "completeWarning") {
            completeDocument()
        } else if (dialog == "skipUploadWarning") {
            skipUpload()
        }

        
    }

    const handleCancel = () => {
        setDialogs(prevState => ({
            ...prevState,
            [dialog]: false
        }));
    }

    const uploadWarningMessage = useMemo(() => {
        if (data.Status == c.status.failed) {
            if ([5001, 5003, 5008, 5009].includes(data.Error_Code)) return msg.doc_upload_retry_file_not_found;
            else return msg.fax_page_after_drop;
        } else {
            if (data?.Entity_Details?.fax_cover_page_drop?.enable == true) return <div>{msg.fax_page_before_drop}<br /><b>Note: The Fax cover (first) page will be permanently removed from the original document and will not be available for review in the G drive.</b><br />The original document will be available in readabl.ai for a limited period of time.<br /></div>;
            else return msg.doc_upload;
        }
    }, [data]);

    const skipUploadWarningMessage = useMemo(() => {
        let selectedFlags = data.Tags.reduce((acc, m) => {
            if (m.enabled) acc[m.tag_display_name] = m.enabled;
            return acc;
        }, {});

        if (data.MRN) {
            if (data.Status == c.status.failed && data?.Entity_Details?.enable_upload_button) return msg.mark_cmp_with_upload_failed;
            else if (selectedFlags["SPAM"]) return msg.spam_mark_cmp_warning
            else return msg.mark_cmp_with_upload
        } else {
            return msg.mark_cmp_without_upload;
        }
    }, [data]);

    return <DialogsWrapper
        open={dialogs[dialog]}
        onClose={handleClose}
    >
        {dialogs.noDoc && <NoDocumentAvailable />}
        {dialogs.blockSave && <BlockSaveWarning handleSubmit={handleSubmit} />}
        {dialogs.dataSave && <SaveMessage />}
        {dialogs.uploadToOnbase && <NoDocumentAvailable />}
        {dialogs.flagNotesNotFilledWarning && <FlagNotesWarning handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {dialogs.spamAlert && <SpamAlert handleSubmit={handleSubmit} />}
        {dialogs.spamFaxNumberValidation && <SpamValidation handleSubmit={handleSubmit} />}
        {dialogs.discardWarning && <DiscardWarning handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {(dialogs.spamWarning || dialogs.errorWarning || dialogs.careEveryWhereWarning || dialogs.duplicateWarning) && <NotificationWarning handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {dialogs.notAvailableWarning && <NotAvailableWarning onNext={() => getDocId("next")} onPrev={() => getDocId("prev")} goToDocManagement={gotToDocMgmt} />}
        {dialogs.splitMessage && <SplitMessage />}
        {dialogs.partialDocumentSplitWarning && <PartialDocSplitWarning handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {dialogs.uploadValidation && <UploadValidation data={data} handleSubmit={handleSubmit} />}
        {dialogs.uploadWarning && <UploadWarning message={uploadWarningMessage} handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {dialogs.completeWarning && <CompleteWarning handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {dialogs.skipUploadWarning && <SkipUploadWarning message={skipUploadWarningMessage} handleSubmit={handleSubmit} handleCancel={handleCancel} />}
        {dialogs.noChangesWarning && <NoChangesWarning handleSubmit={handleSubmit} />}

    </DialogsWrapper>
}

export default Dialogs;